module.exports = __webpack_public_path__ + "static/media/lock.490572e9.svg";